<template>
  <b-modal
    size="xl"
    modal-class="bd-modal"
    v-model="localValue"
    hide-footer
    @hidden="reset"
    no-close-on-backdrop
    @show="$root.$emit('app:unload-prompt', true)"
  >
    <NxBWizard
      content-class="mt-3"
      align="center"
      class="mb-4"
      v-model="step"
      lazy
      pills
      vertical
      ref="wizard"
    >
      <NxBWizardStep :title="$t('SignMethod')">
        <NxSigningModalMethod v-model="source" v-on="stepActions" />
      </NxBWizardStep>
      <NxBWizardStep  :title="$t('Digest')">
        <NxSigningModalDigest v-model="source" v-on="stepActions" />
      </NxBWizardStep>

      
      <NxBWizardStep :title="$t('ConnectSigningAgent')">
        <NxSigningModalMethodP12Batch
          v-model="source"
          v-if="source.signMethod === 'SIGN_P12'"
          v-on="stepActions"
        />
        <NxSigningModalMethodTokenBatch
          v-model="source"
          v-else-if="source.signMethod === 'SIGN_TOKEN'"
          v-on="stepActions"
        />
        <NxSigningModalMethodIAMSmartBatch
          v-model="source"
          v-else-if="source.signMethod === 'SIGN_IAM_SMART'"
          v-on="stepActions"
        />
        <div v-else>
          <b-alert show variant="danger">Undefined sign method</b-alert>
        </div>
      </NxBWizardStep>
        

      <NxBWizardStep :title="$t('MergeDocument')" v-if="source.signMethod !== 'SIGN_IAM_SMART'">
        <!-- <NxSigningModalMergeDoc v-model="source" v-on="stepActions" :is-non-pdf="isNonPdf" :file-id="fileId" :is-drawing="isDrawing" /> -->
        <NxSigningModalMergeDocBatch v-model="source" v-on="stepActions" />
      </NxBWizardStep>

      <NxBWizardStep  :title="$t('SignCompleted')">
        <NxSigningModalAddCertComplete
          v-model="source"
          v-on="stepActions"
          @signComplete="signComplete()"
        />
      </NxBWizardStep>

      <NxBWizardStep :title="$t('SignFail')" :hide-step="step !== failStep">
        <NxSigningModalAddCertFailure v-model="source" v-on="stepActions" />
      </NxBWizardStep>
    </NxBWizard>
  </b-modal>
</template>

<script>
import { NxBWizard, NxBWizardStep } from '@nextore/nx-b-wizard';
import { BModal, BAlert } from 'bootstrap-vue';
import NxSigningModalInit from './NxSigningModalInit';
import NxSigningModalMethod from './NxSigningModalMethod';
import NxSigningModalMethodP12 from './NxSigningModalMethodP12';
import NxSigningModalMethodToken from './NxSigningModalMethodToken';
import NxSigningModalAddCertComplete from './NxSigningModalAddCertComplete';
import NxSigningModalMergeDoc from './NxSigningModalMergeDoc';
import NxSigningModalSignature from './NxSigningModalSignature';
import NxSigningModalField from './NxSigningModalField';
import NxSigningModalDigest from './NxSigningModalDigest';
import NxSigningModalAddCertFailure from './NxSigningModalAddCertFailure';
import NxSigningModalMethodIAMSmart from './NxSigningModalMethodIAMSmart';
import NxSigningModalMethodP12Batch from './NxSigningModalMethodP12Batch';
import NxSigningModalMethodTokenBatch from './NxSigningModalMethodTokenBatch';
import NxSigningModalMethodIAMSmartBatch from './NxSigningModalMethodIAMSmartBatch';
import NxSigningModalMergeDocBatch from './NxSigningModalMergeDocBatch';

export default {
  components: {
    BModal,
    BAlert,
    NxBWizard,
    NxBWizardStep,
    NxSigningModalInit,
    NxSigningModalMethod,
    NxSigningModalMethodP12,
    NxSigningModalMethodToken,
    NxSigningModalAddCertComplete,
    NxSigningModalMergeDoc,
    NxSigningModalSignature,
    NxSigningModalField,
    NxSigningModalDigest,
    NxSigningModalAddCertFailure,
    NxSigningModalMethodIAMSmart,
    NxSigningModalMethodP12Batch,
    NxSigningModalMethodTokenBatch,
    NxSigningModalMethodIAMSmartBatch,
    NxSigningModalMergeDocBatch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // fileId: {}
    files: {
      type: Array
    },
    guid:{
      type:String
    },
    isRegistration: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      source: this.getInitSource(),
      step: 0
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    failStep() {
      if(this.isRegistration){
        return this.source.signMethod === 'SIGN_IAM_SMART'?4:5;
      }else{
        return this.source.signMethod === 'SIGN_IAM_SMART'?3:4;
      }
    },
    stepActions() {
      return {
        next: this.next,
        fail: () => this.next(this.failStep)
      };
    }
  },
  watch: {
    files: {
      handler(files) {
        this.source = { ...this.source, files };
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      this.source = this.getInitSource();
      this.step = 0;
    },
    getInitSource() {
      return {
        guid:this.guid,
        signInfo: null,
        field: null,
        digest: null,
        signature: null,
        files: this.files,
        signMethod: null
      };
    },
    next(step) {
      if (step !== undefined) {
        this.step = step;
      } else {
        this.step++;
      }
    },
    signComplete() {
      this.$emit('signComplete');
    }
  },  i18n: {
    messages: {
      en: {
        Digest: 'Digest',
        SignMethod: 'Sign Method',
        ConnectSigningAgent: 'Connect to signing agent',
        MergeDocument: 'Merge document',
        SignCompleted: 'Adding e-Certificate succeeded',
        SignFail: 'Adding e-Certificate Fail'
      },
      zh_hk: {
        Digest: '文摘',
        SignMethod: '簽名方法',
        ConnectSigningAgent: '連接到簽名代理',
        MergeDocument: '合併文檔',
        SignCompleted: '成功加入電子證書',
        SignFail: '加入電子證書失敗'
      },
      zh_cn: {
        Digest: '文摘',
        SignMethod: '签名方法',
        ConnectSigningAgent: '连接到签名代理',
        MergeDocument: '合并文档',
        SignCompleted: '成功加入电子证书',
        SignFail: '加入电子证书失败'
      }
    }
  }
};
</script>

<style>
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>
